import React, { useState } from "react"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import { IconButton, makeStyles, CircularProgress } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { deleteEventRequest, setEventFormOpen, setSelectedEvent } from "../../actions/eventActions"
import useUser from "../../utils/customHooks/useUser"
import ConfirmationDialog from "../common/dialog/ConfirmationDialog"

const useStyles = makeStyles((theme) => ({
	menu: {
		color: theme.palette.grey.D300,
		paddingBottom: 0,
	},
	progress: {
		marginRight: 5,
	},
}))

const EventMenu = ({ event }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const { currentUser } = useUser()
	const isUpdating = useSelector((state) => state.events.isUpdating)
	const updateId = useSelector((state) => state.events.updateId)

	const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
	const eventName = event?.name

	const [anchorEl, setAnchorEl] = useState(null)
	const open = Boolean(anchorEl)
	const options = [
		{ label: t("event.edit"), action: handleEdit, disabled: false },
		{ label: t("event.delete"), action: handleDeleteConfirm, disabled: false },
	]

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	function handleEdit(event) {
		dispatch(setSelectedEvent(event))
		dispatch(setEventFormOpen(true))
		handleClose()
	}

	function handleDeleteConfirm(event) {
		setOpenDeleteConfirm((prev) => true)
		handleClose()
	}

	const deleteEvent = () => {
		if (!_.isEmpty(event)) {
			dispatch(deleteEventRequest(event))
			setOpenDeleteConfirm((prev) => false)
		}
	}

	const deleteEventCancel = () => {
		setOpenDeleteConfirm((prev) => false)
	}

	return (
		<>
			{currentUser?.userid === event?.userid ? (
				<>
					{updateId === event.id && isUpdating ? (
						<>
							<CircularProgress size={15} className={classes.progress} />
						</>
					) : (
						<>
							<IconButton
								className={classes.menu}
								aria-label="more"
								aria-controls="long-menu"
								aria-haspopup="true"
								onClick={handleClick}
							>
								<MoreVertIcon />
							</IconButton>
							<Menu
								id="long-menu"
								anchorEl={anchorEl}
								keepMounted
								open={open}
								onClose={handleClose}
								anchorOrigin={{
									vertical: "bottom",
									horizontal: "left",
								}}
								transformOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
							>
								{options.map((option) => (
									<MenuItem
										key={option.label}
										onClick={() => {
											option.action(event)
											handleClose()
										}}
										disabled={option.disabled || isUpdating}
									>
										{option.label}
									</MenuItem>
								))}
							</Menu>
							<ConfirmationDialog
								open={openDeleteConfirm}
								title={t("event.confirmDelete.title")}
								message={
									<span dangerouslySetInnerHTML={{ __html: t("event.confirmDelete.deleteMessage", { eventName }) }} />
								}
								btnText={t("event.confirmDelete.deleteBtn")}
								onConfirm={deleteEvent}
								onDismiss={deleteEventCancel}
							/>
						</>
					)}
				</>
			) : (
				<></>
			)}
		</>
	)
}

export default EventMenu
